module.exports = __webpack_public_path__ + "img/logo.b472c586.png";